import React from 'react';

import {
	isSearchResultJiraBoard,
	isSearchResultJiraDashboard,
	isSearchResultJiraFilter,
	isSearchResultJiraIssue,
	isSearchResultJiraProject,
	type SearchJiraPartial,
} from '@atlassian/dynamic-cards-search-client';

import { ProductKeys } from '../../../../../../../common/constants/products';
import { ProductIcon } from '../../../../../../../common/ui/product-icon';

const jiraProjectProductMap = {
	software: ProductKeys.Jira,
	business: ProductKeys.Jira,
	service_desk: ProductKeys.JiraServiceManagement,
	product_discovery: ProductKeys.JiraProductDiscovery,
};

const jiraIssueProductMap = {
	SOFTWARE: ProductKeys.Jira,
	BUSINESS: ProductKeys.Jira,
	SERVICE_DESK: ProductKeys.JiraServiceManagement,
	PRODUCT_DISCOVERY: ProductKeys.JiraProductDiscovery,
};

const jiraBoardProductMap = {
	SOFTWARE: ProductKeys.Jira,
	BUSINESS: ProductKeys.Jira,
};

export const JiraProductIcon = ({ partial }: { partial: SearchJiraPartial }): React.JSX.Element => {
	let product: 'jira' | 'jira-product-discovery' | 'jira-servicedesk' = ProductKeys.Jira;

	if (isSearchResultJiraProject(partial)) {
		product = jiraProjectProductMap[partial.projectType];
	} else if (isSearchResultJiraIssue(partial)) {
		const projectType = partial?.issue?.fieldsById.edges[0]?.node.project.projectType;
		product = projectType ? jiraIssueProductMap[projectType] : product;
	} else if (isSearchResultJiraBoard(partial)) {
		product = jiraBoardProductMap[partial.product];
	} else if (isSearchResultJiraFilter(partial)) {
		// TODO: Add the app mapping once we support jira filters
	} else if (isSearchResultJiraDashboard(partial)) {
		// TODO: Add the app mapping once we support jira dashboards
	}

	return <ProductIcon product={product} />;
};
